import React from 'react'
import Main from '../components/HostelFacilities/Main'

const HostelFacilities = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default HostelFacilities